export const WorksData = [
    {
        title: 'Creative Agency website',
        content: 'A nicer look agency website that has service features, client and backend dashboard. Here also e-commerce functionality to manage clients and sales.',
        languages: ['JavaScript', 'React', 'express', 'mongodb', 'SCSS', 'HTML'],
        links: [
            {   
                _id: 1,
                link: 'https://github.com/nokibrokes/creative-agency-frontend',
                text: 'github'
            },
            {   
                _id: 2,
                link: 'https://creative-agency-frontend.web.app/',
                text: 'live'
            }
        ],
        image: require('./images/portfolio/creative-agency.jpg')
    },
    {
        title: 'Red Onion Restaurant',
        content: 'A restaurant website that has fully functional e-commerce features and attractive design. Here the client can purchase food and the admin can manage sales.',
        languages: ['JavaScript', 'React', 'express', 'mongodb', 'SCSS', 'HTML'],
        links: [
            {   
                _id: 1,
                link: 'https://github.com/nokibrokes/hot-oniton-restaurant',
                text: 'github'
            },
            {   
                _id: 2,
                link: 'https://red-onion-restaurant-demo.web.app/',
                text: 'live'
            }
        ],
        image: require('./images/portfolio/hot-oninon-resturant.jpg')
    }
    ,
    {
        title: 'Volunteer service website',
        content: 'A service providing website full functional website where has a full authentication system. Here user can add volunteer service and the admin can manage that.',
        languages: ['React', 'express', 'mongodb', 'firebase', 'SCSS', 'HTML'],
        links: [
            {   
                _id: 1,
                link: 'https://github.com/nokibrokes/volunteer-network-client',
                text: 'github'
            },
            {   
                _id: 2,
                link: 'https://volunteer-network-frontend.web.app/',
                text: 'live'
            }
        ],
        image: require('./images/portfolio/volunteer-service.jpg')
    },
    {
        title: 'Simple auto refresher chrome extension',
        content: 'A simple tool to make the website live every time! Refresh your pages with selected time interval. feel free to check that.',
        languages: ['Chrome extension', 'JavaScript', 'Gumroad API', 'CSS', 'HTML'],
        links: [
            {   
                _id: 1,
                link: 'https://shorturl.at/uwGTZ',
                text: 'chrome'
            },
            
        ],
        image: require('./images/portfolio/simple-auto-refresher.jpg')
    },
    {
        title: 'Dark mode dashboard panel',
        content: 'A dark mode theme where many cards are there to indicate the information also they have great pixel perfect design. Where the user will get an awesome experience.',
        languages: ['JavaScript', 'SCSS', 'HTML'],
        links: [
            {   
                _id: 1,
                link: 'https://github.com/nokibrokes/social-media-dashboard',
                text: 'github'
            },
            {   
                _id: 2,
                link: 'https://social-media-dashboard-gold.vercel.app/',
                text: 'live'
            }
        ],
        image: require('./images/portfolio/dark-mode-dashboard.jpg')
    },
    {
        title: 'Insurance finance landing page',
        content: 'An insurance finance company landing page where all the design implemented by pixel perfect and site are fully responsive.',
        languages: ['JavaScript', 'SCSS', 'HTML'],
        links: [
            {   
                _id: 1,
                link: 'https://github.com/nokibrokes/insture-landing-page',
                text: 'github'
            },
            {   
                _id: 2,
                link: 'https://insture-landing-page.vercel.app/',
                text: 'live'
            }
        ],
        image: require('./images/portfolio/insure-finance-landing-page.jpg')
    },
    {
        title: 'Fylo responsive landing page',
        content: "A file storage company's landing page which is responsive and pixel perfect.",
        languages: ['JavaScript', 'SCSS', 'HTML'],
        links: [
            {   
                _id: 1,
                link: 'https://github.com/nokibrokes/fylo-dark-theme-landing-page',
                text: 'github'
            },
            {   
                _id: 2,
                link: 'https://fylo-dark-landing-page-demo.vercel.app/',
                text: 'live'
            }
        ],
        image: require('./images/portfolio/fylo-dark-theme.jpg')
    }
]


export const ArticlesData = [
    {
        _id: 1,
        title: "What's my experience learning React after Vue",
        content: 'As a full-stack web developer science 2016 and Recently I learn react after Vue courses. Here I will tell you why you need to learn react 1st',
        link: 'https://medium.com/p/915951d8eb89',
        languages: ['React.JS', 'VUE.JS',  "Web Design"],
        image: 'https://miro.medium.com/max/1280/1*aLg1-G2UAlaKpBopRnmCRg.png'
    },
    {
        _id: 2,
        title: 'How I learn JavaScript by doing projects.',
        content: 'JavaScript widely uses language and almost every kind of project you can use this language. If you want to learn this, you can from online.',
        link: 'https://medium.com/p/c4ed39a17f5e',
        languages: ['javaScript', 'web development', 'resource'],
        image: 'https://miro.medium.com/max/1280/1*aLg1-G2UAlaKpBopRnmCRg.png'
    },
    {
        _id: 3,
        title: 'Introducing Simple Auto Refresher Chrome Extension',
        content: 'Building a custom multisite compatible WordPress plugin to build global search with Algolia',
        link: 'https://medium.com/p/9b5d2ed6703d',
        languages: ['Chrome Extension', 'JavaScript'],
        image: 'https://miro.medium.com/max/1280/1*aLg1-G2UAlaKpBopRnmCRg.png'
    },
    
]



export const ServiceIProvide = [
    {
        _id: 1,
        title: "Web Design",
        content: "Todays trend is modern website design. Which help to grow a business. Almost every new and old business should focus on design which can attract customer and become a client.",
        image: require('./images/computer.svg')
    },
    {
        _id: 2,
        title: "Web Development",
        content: "Almost every middle and large company needs website & web apps. Here i provide that service with modern design and strong security. Which will grow every business.",
        image: require('./images/data.svg')
    },
    {
        _id: 1,
        title: "Web Security",
        content: "In every single day, more then ten thousand website got hack by hacker due to security reason. Check your website vulnerability to not hack next and protect business growth.",
        image: require('./images/security.svg')
    }
] 

export const SkillData = [
    {
        title: 'HTML5',
        image: require('./images/html.png'),
    },
    {
        title: 'CSS3',
        image: require('./images/css3.png'),
    },
    {
        title: 'JavaScript',
        image: require('./images/js.png'),
    },
    {
        title: 'React',
        image: require('./images/react.png'),
    },
    {
        title: 'PHP',
        image: require('./images/php.jpg'),
    },
    {
        title: 'Laravel',
        image: require('./images/laravel.png'),
    }
]


export const ToolsData = [
    {
        title: 'VS Code',
        image: require('./images/vscode.png')
    },
    {
        title: 'Adove Xd',
        image: require('./images/xd.png')
    },
    {
        title: 'github',
        image: require('./images/github.svg')
    },
   
]


export const AboutMeData = {
    _id : 1,
    content: `Hey! I am Ariful Mowla Nokib, a full-stack web-developer & security expert. I enjoy learning new technology and creating new things that live on the internet. My goal is to always build products that provide pixel-perfect, performant experiences.
        <br> <br>
    After completing my graduation I provide web services as full time. Previously I worked on many freelance projects, But I fully dedicated to programming. Here are a few technologies I've been working with recently:`,
    technology: ['JavaScript (ES6+)', 'HTML & (S)CSS', 'React', 'Vue', "Node.js", 'WordPress', 'PHP', 'Laravel'],
    shortDes: 'I am a self-taught full-stack web Developer and security expert, Who loves to coding and debag until fixing all errors. I help people to execute there plan in digital platform and grow revenue.',
    image: require('./images/about.jpg')
}

export const ResumeData = "https://docs.google.com/document/d/1TvwhSn80waK-jZnOnN2Vig7qLYNKh5eXEzLZmWwUj-A/edit?usp=sharing";